import { useMemo } from "react";
import {
  PortalAdditionalReportGroupViewModel,
  PortalAdditionalReportViewModel,
} from "../../../../generated/data-contracts";
import { NoDataPage } from "../../../shared/error/NoDataPage";
import { ReportsListGroupItem } from "./ReportsListGroupItem";

interface IReportsListProps {
  reports: PortalAdditionalReportGroupViewModel[];
  selectedReport: PortalAdditionalReportViewModel | undefined;
  setSelectedReport: (
    report: PortalAdditionalReportViewModel | undefined,
  ) => void;
}
export function ReportsList(props: Readonly<IReportsListProps>) {
  const { reports, selectedReport, setSelectedReport } = props;

  const renderContent = useMemo(() => {
    if (!reports || reports?.length === 0) {
      return <NoDataPage />;
    }

    return (
      <div className="report-list grid">
        {reports.map((item) => {
          return (
            <ReportsListGroupItem
              key={item.portalAdditionalReportGroupId}
              reportGroup={item}
              selectedReport={selectedReport}
              setSelectedReport={setSelectedReport}
            />
          );
        })}
      </div>
    );
  }, [reports, selectedReport, setSelectedReport]);

  return <div>{renderContent}</div>;
}
